import { takeEvery, put, call } from "redux-saga/effects"
import { toast } from "react-toastify";

import { ADD_APPOINTMENT_LOCATION_TYPE, ADD_APPOINTMENT_PRIORITY, ADD_APPOINTMENT_TYPE, ADD_CAMPAIGN_EMAIL_LIST, ADD_CONTACT_LEVEL, ADD_CONTACT_STATUS, ADD_CONTACT_TYPE, ADD_EMAIL_LIST_TARGET, ADD_EMAIL_LIST_TYPE, ADD_LEAD_CLASSIFICATION, ADD_LEAD_SOURCE, ADD_LEAD_STAGE, ADD_LEAD_STATUS, ADD_LEAD_TYPE, ADD_LISTING_STATUS, ADD_LISTING_TYPE, ADD_NOTE_TYPE, ADD_PROJECT_DOCUMENT_TYPE, ADD_PROJECT_STATUS, ADD_PROJECT_TYPE, ADD_SERVICE_TYPE, ADD_SHOWING_STATUS, ADD_TASK_PRIORITY, ADD_TASK_REMINDER, ADD_TASK_STATUS, ADD_TASK_TYPE, ADD_TRANSACTION_COMMISSION_TYPE, ADD_TRANSACTION_REF_TYPE, ADD_TRANSACTION_STATUS_TYPE, ADD_TRANSACTION_TYPE, DELETE_APP_BY_PAGE_TYPE, DELETE_APPOINTMENT_LOCATION_TYPE, DELETE_APPOINTMENT_PRIORITY, DELETE_APPOINTMENT_TYPE, DELETE_CAMPAIGN_EMAIL_LIST, DELETE_CONTACT_LEVEL, DELETE_CONTACT_STATUS, DELETE_CONTACT_TYPE, DELETE_EMAIL_LIST_TARGET, DELETE_EMAIL_LIST_TYPE, DELETE_LEAD_CLASSIFICATION, DELETE_LEAD_SOURCE, DELETE_LEAD_STAGE, DELETE_LEAD_STATUS, DELETE_LEAD_TYPE, DELETE_LISTING_STATUS, DELETE_LISTING_TYPE, DELETE_NOTE_TYPE, DELETE_PROJECT_DOCUMENT_TYPE, DELETE_PROJECT_STATUS, DELETE_PROJECT_TYPE, DELETE_SERVICE_TYPE, DELETE_SHOWING_STATUS, DELETE_TASK_PRIORITY, DELETE_TASK_REMINDER, DELETE_TASK_STATUS, DELETE_TASK_TYPE, DELETE_TRANSACTION_COMMISSION_TYPE, DELETE_TRANSACTION_REF_TYPE, DELETE_TRANSACTION_STATUS_TYPE, DELETE_TRANSACTION_TYPE, GET_APP_BY_PAGE_TYPE, GET_APPOINTMENT_LOCATION_TYPE, GET_APPOINTMENT_PRIORITY, GET_APPOINTMENT_TYPE, GET_CAMPAIGN_EMAIL_LIST, GET_CONTACT_LEVEL, GET_CONTACT_STATUS, GET_CONTACT_TYPE, GET_EMAIL_LIST_TARGET, GET_EMAIL_LIST_TYPE, GET_LEAD_CLASSIFICATION, GET_LEAD_SOURCE, GET_LEAD_STAGE, GET_LEAD_STATUS, GET_LEAD_TYPE, GET_LISTING_STATUS, GET_LISTING_TYPE, GET_NOTE_TYPE, GET_PROJECT_DOCUMENT_TYPE, GET_PROJECT_STATUS, GET_PROJECT_TYPE, GET_SERVICE_TYPE, GET_SHOWING_STATUS, GET_TASK_PRIORITY, GET_TASK_REMINDER, GET_TASK_STATUS, GET_TASK_TYPE, GET_TRANSACTION_COMMISSION_TYPE, GET_TRANSACTION_REF_TYPE, GET_TRANSACTION_REF_TYPE_FAIL, GET_TRANSACTION_STATUS_TYPE, GET_TRANSACTION_TYPE, UPDATE_APP_BY_PAGE_TYPE, UPDATE_APPOINTMENT_LOCATION_TYPE, UPDATE_APPOINTMENT_PRIORITY, UPDATE_APPOINTMENT_TYPE, UPDATE_CAMPAIGN_EMAIL_LIST, UPDATE_CONTACT_LEVEL, UPDATE_CONTACT_STATUS, UPDATE_CONTACT_TYPE, UPDATE_EMAIL_LIST_TARGET, UPDATE_EMAIL_LIST_TYPE, UPDATE_LEAD_CLASSIFICATION, UPDATE_LEAD_SOURCE, UPDATE_LEAD_STAGE, UPDATE_LEAD_STATUS, UPDATE_LEAD_TYPE, UPDATE_LISTING_STATUS, UPDATE_LISTING_TYPE, UPDATE_NOTE_TYPE, UPDATE_PROJECT_DOCUMENT_TYPE, UPDATE_PROJECT_STATUS, UPDATE_PROJECT_TYPE, UPDATE_SERVICE_TYPE, UPDATE_SHOWING_STATUS, UPDATE_TASK_PRIORITY, UPDATE_TASK_REMINDER, UPDATE_TASK_STATUS, UPDATE_TASK_TYPE, UPDATE_TRANSACTION_COMMISSION_TYPE, UPDATE_TRANSACTION_REF_TYPE, UPDATE_TRANSACTION_STATUS_TYPE, UPDATE_TRANSACTION_TYPE } from "./actionTypes"
import { addAppLocationTypeError, addAppLocationTypeSuccess, addAppointmentPriorityError, addAppointmentPrioritySuccess, addAppointmentTypeError, addAppointmentTypeSuccess, addCampaignEmailListError, addCampaignEmailListSuccess, addContactLevelError, addContactLevelSuccess, addContactStatusError, addContactStatusSuccess, addContactTypeError, addContactTypeSuccess, addEmailListTargetError, addEmailListTargetSuccess, addEmailListTypeError, addEmailListTypeSuccess, addLeadClassificationError, addLeadClassificationSuccess, addLeadSourceError, addLeadSourceSuccess, addLeadStageError, addLeadStageSuccess, addLeadStatusError, addLeadStatusSuccess, addLeadTypeError, addLeadTypeSuccess, addListingStatusError, addListingStatusSuccess, addListingTypeError, addListingTypeSuccess, addNoteTypeError, addNoteTypeSuccess, addProjectDocTypeError, addProjectDocTypeSuccess, addProjectStatusError, addProjectStatusSuccess, addProjectTypeError, addProjectTypeSuccess, addServiceTypeError, addServiceTypeSuccess, addShowingStatusError, addShowingStatusSuccess, addTaskPriorityError, addTaskPrioritySuccess, addTaskReminderError, addTaskReminderSuccess, addTaskStatusError, addTaskStatusSuccess, addTaskTypeError, addTaskTypeSuccess, addTransCommTypeError, addTransCommTypeSuccess, addTransRefTypeError, addTransStatusTypeError, addTransStatusTypeSuccess, addTransTypeError, addTransTypeSuccess, deleteAppLocationTypeFail, deleteAppLocationTypeSuccess, deleteAppointmentPriorityFail, deleteAppointmentPrioritySuccess, deleteAppointmentTypeFail, deleteAppointmentTypeSuccess, deleteCalendarAppFail, deleteCalendarAppSuccess, deleteContactLevelFail, deleteContactLevelSuccess, deleteContactStatusFail, deleteContactStatusSuccess, deleteContactTypeFail, deleteContactTypeSuccess, deleteEmailListTargetFail, deleteEmailListTargetSuccess, deleteEmailListTypeFail, deleteEmailListTypeSuccess, deleteLeadClassificationFail, deleteLeadClassificationSuccess, deleteLeadSourceFail, deleteLeadSourceSuccess, deleteLeadStageFail, deleteLeadStageSuccess, deleteLeadStatusFail, deleteLeadStatusSuccess, deleteLeadTypeFail, deleteLeadTypeSuccess, deleteListingStatusFail, deleteListingStatusSuccess, deleteListingTypeFail, deleteListingTypeSuccess, deleteNoteTypeFail, deleteNoteTypeSuccess, deleteProjectDocTypeFail, deleteProjectStatusFail, deleteProjectStatusSuccess, deleteProjectTypeFail, deleteProjectTypeSuccess, deleteServiceTypeFail, deleteServiceTypeSuccess, deleteShowingStatusFail, deleteShowingStatusSuccess, deleteTaskPriorityFail, deleteTaskPrioritySuccess, deleteTaskReminderFail, deleteTaskReminderSuccess, deleteTaskStatusFail, deleteTaskStatusSuccess, deleteTaskTypeFail, deleteTaskTypeSuccess, deleteTransCommTypeFail, deleteTransCommTypeSuccess, deleteTransStatusTypeFail, deleteTransStatusTypeSuccess, deleteTransTypeFail, deleteTransTypeSuccess, getAppDetailByIdFail, getAppDetailByIdSuccess, getAppLocationTypeFail, getAppLocationTypeSuccess, getAppointmentPriorityFail, getAppointmentPrioritySuccess, getAppointmentTypeFail, getAppointmentTypeSuccess, getCampaignEmailListError, getCampaignEmailListSuccess, getContactLevelFail, getContactLevelSuccess, getContactStatusFail, getContactStatusSuccess, getContactTypeFail, getContactTypeSuccess, getEmailListTargetFail, getEmailListTargetSuccess, getEmailListTypeFail, getEmailListTypeSuccess, getLeadClassificationFail, getLeadClassificationSuccess, getLeadSourceFail, getLeadSourceSuccess, getLeadStageFail, getLeadStageSuccess, getLeadStatusFail, getLeadStatusSuccess, getLeadTypeSuccess, getListingStatusFail, getListingStatusSuccess, getListingTypeFail, getListingTypeSuccess, getNoteTypeFail, getNoteTypeSuccess, getProjectDocTypeFail, getProjectDocTypeSuccess, getProjectStatusFail, getProjectStatusSuccess, getProjectTypeFail, getProjectTypeSuccess, getServiceTypeFail, getServiceTypeSuccess, getShowingStatusFail, getShowingStatusSuccess, getTaskPriorityFail, getTaskPrioritySuccess, getTaskReminderFail, getTaskReminderSuccess, getTaskStatusFail, getTaskStatusSuccess, getTaskTypeFail, getTaskTypeSuccess, getTransCommTypeFail, getTransCommTypeSuccess, getTransRefTypeFail, getTransRefTypeSuccess, getTransStatusTypeFail, getTransStatusTypeSuccess, getTransTypeFail, getTransTypeSuccess, updateAppLocationTypeFail, updateAppointmentPriorityFail, updateAppointmentTypeFail, updateCampaignEmailListFail, updateContactLevelFail, updateContactStatusFail, updateContactTypeFail, updateEmailListTargetFail, updateEmailListTypeFail, updateLeadClassficationFail, updateLeadSourceFail, updateLeadStageFail, updateLeadStatusFail, updateLeadTypeFail, updateListingStatusFail, updateListingTypeFail, updateNoteTypeFail, updateProjectDocTypeFail, updateProjectStatusFail, updateProjectTypeFail, updateServiceTypeFail, updateShowingStatusFail, updateTaskPriorityFail, updateTaskReminderFail, updateTaskStatusFail, updateTaskTypeFail, updateTransCommTypeFail, updateTransRefTypeFail, updateTransStatusTypeFail, updateTransTypeFail } from "./actions"

import { contactAppDetailApi, deleteAppLocationTypeAPI, deleteAppointmentPriorityAPI, deleteAppointmentTypeAPI, deleteCalAppApi, deleteCampaignEmailListApi, deleteContactLevelAPI, deleteContactStatusAPI, deleteContactTypeAPI, deleteEmailListTargetApi, deleteEmailListTypeApi, deleteLeadClassificatioAPI, deleteLeadSourceAPI, deleteLeadStageAPI, deleteLeadStatusAPI, deleteLeadTypeAPI, deleteListingStatusApi, deleteListingTypeApi, deleteNoteTypeAPI, deleteProjectDocTypeAPI, deleteProjectStatusAPI, deleteProjectTypeAPI, deleteServiceTypeAPI, deleteShowingStatusApi, deleteTaskPriorityAPI, deleteTaskReminderAPI, deleteTaskStatusAPI, deleteTaskTypeAPI, deleteTransactionCommAPI, deleteTransactionRefAPI, deleteTransactionStatusAPI, deleteTransactionTypeAPI, getAppLocationTypeAPI, getAppointmentPriorityAPI, getAppointmentTypeAPI, getCampaignEmailListApi, getContactLevelAPI, getContactStatusAPI, getContactTypeAPI, getEmailListTargetApi, getEmailListTypeApi, getLeadClassificatioAPI, getLeadSourceAPI, getLeadStageAPI, getLeadStatusAPI, getLeadTypeAPI, getListingStatusApi, getListingTypeApi, getNoteTypeAPI, getProjectDocTypeAPI, getProjectDocumentApi, getProjectStatusAPI, getProjectTypeAPI, getServiceTypeAPI, getShowingStatusApi, getTaskPriorityAPI, getTaskReminderAPI, getTaskStatusAPI, getTaskTypeAPI, getTransactionCommAPI, getTransactionRefAPI, getTransactionStatusAPI, getTransactionTypeAPI, leadAppDetailApi, postAppLocationTypeAPI, postAppointmentPriorityAPI, postAppointmentTypeAPI, postCampaignEmailListApi, postContactLevelAPI, postContactStatusAPI, postContactTypeAPI, postEmailListTargetApi, postEmailListTypeApi, postLeadClassificationAPI, postLeadSourceAPI, postLeadStageAPI, postLeadStatusAPI, postLeadTypeAPI, postListingStatusApi, postListingTypeApi, postNoteTypeAPI, postProjectDocTypeAPI, postProjectStatusAPI, postProjectTypeAPI, postServiceTypeAPI, postShowingStatusApi, postTaskPriorityAPI, postTaskReminderAPI, postTaskStatusAPI, postTaskTypeAPI, postTransactionCommAPI, postTransactionRefAPI, postTransactionStatusAPI, postTransactionTypeAPI, updateAppLocationTypeAPI, updateAppointmentPriorityAPI, updateAppointmentTypeAPI, updateCalAppApi, updateCampaignEmailListApi, updateContactLevelAPI, updateContactStatusAPI, updateContactTypeAPI, updateEmailListTargetApi, updateEmailListTypeApi, updateLeadClassificatioAPI, updateLeadSourceAPI, updateLeadStageAPI, updateLeadStatusAPI, updateLeadTypeAPI, updateListingStatusApi, updateListingTypeApi, updateNoteTypeAPI, updateProjectDocTypeAPI, updateProjectStatusAPI, updateProjectTypeAPI, updateServiceTypeAPI, updateShowingStatusApi, updateTaskPriorityAPI, updateTaskReminderAPI, updateTaskStatusAPI, updateTaskTypeAPI, updateTransactionCommAPI, updateTransactionRefAPI, updateTransactionStatusAPI, updateTransactionTypeAPI } from "../../helpers/backend_helper"

function* submitAppLocationType({ payload: { location, history } }) {
  try {

    toast.loading("Please wait...")
    const response = yield call(postAppLocationTypeAPI, {

      appointmentLocationTypeTitle: location.appointmentLocationTypeTitle,
      agentId: parseInt(localStorage.getItem('userId'))
    })
    yield put(addAppLocationTypeSuccess(response))
    if (response.success == true) {
      toast.dismiss();
      toast.success("Saved Successfully");
      const response = yield call(getAppLocationTypeAPI, parseInt(localStorage.getItem('userId')))
      yield put(getAppLocationTypeSuccess(response))
    } else {
      toast.dismiss();
      toast.warn(response.validationErrors[0]);
    }
  }
  catch (error) {

    yield put(addAppLocationTypeError('Some Error'))
  }
}

function* fetchAppLocationType({ agentId }) {
  try {
    const response = yield call(getAppLocationTypeAPI, agentId)
    yield put(getAppLocationTypeSuccess(response))
  } catch (error) {
    yield put(getAppLocationTypeFail(error))
  }
}

function* onDeleteAppLocationType({ payload: locationType }) {
  try {
    toast.loading("Please wait...")
    const response = yield call(deleteAppLocationTypeAPI, locationType.id)
    yield put(deleteAppLocationTypeSuccess(response))
    toast.dismiss();
    toast.success("Deleted Successfully");
    const res = yield call(getAppLocationTypeAPI, locationType.agentId)
    yield put(getAppLocationTypeSuccess(res))

  } catch (error) {
    yield put(deleteAppLocationTypeFail(error))
  }
}


function* onUpdateLocationType({ payload:  { locationType, callback } }) {
  try {
    toast.loading("Please wait...")
    const response = yield call(updateAppLocationTypeAPI, locationType)
    if(response.success==true){
    toast.dismiss();
    toast.success("Updated Successfully");
    const res = yield call(getAppLocationTypeAPI, locationType.agentId)
    if (callback) {
       
        callback(true);
      }
    yield put(getAppLocationTypeSuccess(res))
    }else{
      toast.dismiss();
      toast.warn(response.validationErrors[0]);
       if (callback) {
       
        callback(false);
      }
    }

  } catch (error) {
    yield put(updateAppLocationTypeFail(error))
  }
}

function* submitAppPriority({ payload: { priority, history } }) {
  try {

    toast.loading("Please wait...")
    const response = yield call(postAppointmentPriorityAPI, {
      appointmentPriorityCode:priority.appointmentPriorityCode,
      appointmentPriorityTitle: priority.appointmentPriorityTitle,
      agentId: parseInt(localStorage.getItem('userId'))
    })
    yield put(addAppointmentPrioritySuccess(response))
    if (response.success == true) {
      toast.dismiss();
      toast.success("Saved Successfully");
      const response = yield call(getAppointmentPriorityAPI, parseInt(localStorage.getItem('userId')))
      yield put(getAppointmentPrioritySuccess(response))
    } else {
      toast.dismiss();
      toast.warn(response.validationErrors[0]);
    }
  }
  catch (error) {

    yield put(addAppointmentPriorityError('Some Error'))
  }
}

function* fetchAppPriority({ agentId }) {
  try {
    const response = yield call(getAppointmentPriorityAPI, agentId)
    yield put(getAppointmentPrioritySuccess(response))
  } catch (error) {
    yield put(getAppointmentPriorityFail(error))
  }
}

function* onDeleteAppPriority({ payload: priority }) {
  try {
    toast.loading("Please wait...")
    const response = yield call(deleteAppointmentPriorityAPI, priority.id)
    yield put(deleteAppointmentPrioritySuccess(response))
    toast.dismiss();
    toast.success("Deleted Successfully");
    const res = yield call(getAppointmentPriorityAPI, priority.agentId)
    yield put(getAppointmentPrioritySuccess(res))

  } catch (error) {
    yield put(deleteAppointmentPriorityFail(error))
  }
}

function* onUpdateAppPriority({ payload: priority }) {
  try {
    toast.loading("Please wait...")
    const response = yield call(updateAppointmentPriorityAPI, priority)
    toast.dismiss();
    toast.success("Updated Successfully");
    const res = yield call(getAppointmentPriorityAPI, priority.agentId)
    yield put(getAppointmentPrioritySuccess(res))


  } catch (error) {
    yield put(updateAppointmentPriorityFail(error))
  }
}


function* submitAppType({ payload: { type, history } }) {
  try {

    toast.loading("Please wait...")
    const response = yield call(postAppointmentTypeAPI, {
      appointmentTypeTitle:type.appointmentTypeTitle,
      agentId: parseInt(localStorage.getItem('userId'))
    })
    yield put(addAppointmentTypeSuccess(response))
    if (response.success == true) {
      toast.dismiss();
      toast.success("Saved Successfully");
      const response = yield call(getAppointmentTypeAPI, parseInt(localStorage.getItem('userId')))
      yield put(getAppointmentTypeSuccess(response))
    } else {
      toast.dismiss();
      toast.warn(response.validationErrors[0]);
    }
  }
  catch (error) {

    yield put(addAppointmentTypeError('Some Error'))
  }
}

function* fetchAppType({ agentId }) {
  try {
    const response = yield call(getAppointmentTypeAPI, agentId)
    yield put(getAppointmentTypeSuccess(response))
  } catch (error) {
    yield put(getAppointmentTypeFail(error))
  }
}

function* onDeleteAppType({ payload: type }) {
  try {
    toast.loading("Please wait...")
    const response = yield call(deleteAppointmentTypeAPI, type.id)
    yield put(deleteAppointmentTypeSuccess(response))
    toast.dismiss();
    toast.success("Deleted Successfully");
    const res = yield call(getAppointmentTypeAPI, type.agentId)
    yield put(getAppointmentTypeSuccess(res))

  } catch (error) {
    yield put(deleteAppointmentTypeFail(error))
  }
}

function* onUpdateAppType({ payload: type }) {
  try {
    toast.loading("Please wait...")
    const response = yield call(updateAppointmentTypeAPI, type)
    toast.dismiss();
    toast.success("Updated Successfully");
    const res = yield call(getAppointmentTypeAPI, type.agentId)
    yield put(getAppointmentTypeSuccess(res))


  } catch (error) {
    yield put(updateAppointmentTypeFail(error))
  }
}

//Contact Level

function* submitContactLevel({ payload: { level, history } }) {
  try {

    toast.loading("Please wait...")
    const response = yield call(postContactLevelAPI, {
      contactLevelTitle:level.contactLevelTitle,
      agentId: parseInt(localStorage.getItem('userId'))
    })
    yield put(addContactLevelSuccess(response))
    if (response.success == true) {
      toast.dismiss();
      toast.success("Saved Successfully");
      const response = yield call(getContactLevelAPI, parseInt(localStorage.getItem('userId')))
      yield put(getContactLevelSuccess(response))
    } else {
      toast.dismiss();
      toast.warn(response.validationErrors[0]);
    }
  }
  catch (error) {

    yield put(addContactLevelError('Some Error'))
  }
}

function* fetchContactLevel({ agentId }) {
  try {
    const response = yield call(getContactLevelAPI, agentId)
    yield put(getContactLevelSuccess(response))
  } catch (error) {
    yield put(getContactLevelFail(error))
  }
}

function* onDeleteContactLevel({ payload: level }) {
  try {
    toast.loading("Please wait...")
    const response = yield call(deleteContactLevelAPI, level.id)
    yield put(deleteContactLevelSuccess(response))
    toast.dismiss();
    toast.success("Deleted Successfully");
    const res = yield call(getContactLevelAPI, level.agentId)
    yield put(getContactLevelSuccess(res))

  } catch (error) {
    yield put(deleteContactLevelFail(error))
  }
}

function* onUpdateContactLevel({ payload: level }) {
  try {
    toast.loading("Please wait...")
    const response = yield call(updateContactLevelAPI, level)
    toast.dismiss();
    toast.success("Updated Successfully");
    const res = yield call(getContactLevelAPI, level.agentId)
    yield put(getContactLevelSuccess(res))


  } catch (error) {
    yield put(updateContactLevelFail(error))
  }
}


//Contact Status

function* submitContactStatus({ payload: { status, history } }) {
  try {

    toast.loading("Please wait...")
    const response = yield call(postContactStatusAPI, {
      contactStatusTitle:status.contactStatusTitle,
      agentId: parseInt(localStorage.getItem('userId'))
    })
    yield put(addContactStatusSuccess(response))
    if (response.success == true) {
      toast.dismiss();
      toast.success("Saved Successfully");
      const response = yield call(getContactStatusAPI, parseInt(localStorage.getItem('userId')))
      yield put(getContactStatusSuccess(response))
    } else {
      toast.dismiss();
      toast.warn(response.validationErrors[0]);
    }
  }
  catch (error) {

    yield put(addContactStatusError('Some Error'))
  }
}

function* fetchContactStatus({ agentId }) {
  try {
    const response = yield call(getContactStatusAPI, agentId)
    yield put(getContactStatusSuccess(response))
  } catch (error) {
    yield put(getContactStatusFail(error))
  }
}

function* onDeleteContactStatus({ payload: status }) {
  try {
    toast.loading("Please wait...")
    const response = yield call(deleteContactStatusAPI, status.id)
    yield put(deleteContactStatusSuccess(response))
    toast.dismiss();
    toast.success("Deleted Successfully");
    const res = yield call(getContactStatusAPI, status.agentId)
    yield put(getContactStatusSuccess(res))

  } catch (error) {
    yield put(deleteContactStatusFail(error))
  }
}

function* onUpdateContactStatus({ payload: status }) {
  try {
    toast.loading("Please wait...")
    const response = yield call(updateContactStatusAPI, status)
    toast.dismiss();
    toast.success("Updated Successfully");
    const res = yield call(getContactStatusAPI, status.agentId)
    yield put(getContactStatusSuccess(res))


  } catch (error) {
    yield put(updateContactStatusFail(error))
  }
}


//Contact Type

function* submitContactType({ payload: { contacttype, history } }) {
  try {

    toast.loading("Please wait...")
    const response = yield call(postContactTypeAPI, {
      contactTypeTitle:contacttype.contactTypeTitle,
      agentId: parseInt(localStorage.getItem('userId'))
    })
    yield put(addContactTypeSuccess(response))
    if (response.success == true) {
      toast.dismiss();
      toast.success("Saved Successfully");
      const response = yield call(getContactTypeAPI, parseInt(localStorage.getItem('userId')))
      yield put(getContactTypeSuccess(response))
    } else {
      toast.dismiss();
      toast.warn(response.validationErrors[0]);
    }
  }
  catch (error) {

    yield put(addContactTypeError('Some Error'))
  }
}

function* fetchContactType({ agentId }) {
  try {
    const response = yield call(getContactTypeAPI, agentId)
    yield put(getContactTypeSuccess(response))
  } catch (error) {
    yield put(getContactTypeFail(error))
  }
}

function* onDeleteContactType({ payload: contacttype }) {
  try {
    toast.loading("Please wait...")
    const response = yield call(deleteContactTypeAPI, contacttype.id)
    yield put(deleteContactTypeSuccess(response))
    toast.dismiss();
    toast.success("Deleted Successfully");
    const res = yield call(getContactTypeAPI, contacttype.agentId)
    yield put(getContactTypeSuccess(res))

  } catch (error) {
    yield put(deleteContactTypeFail(error))
  }
}

function* onUpdateContactType({ payload: contacttype }) {
  try {
    toast.loading("Please wait...")
    const response = yield call(updateContactTypeAPI, contacttype)
    toast.dismiss();
    toast.success("Updated Successfully");
    const res = yield call(getContactTypeAPI, contacttype.agentId)
    yield put(getContactTypeSuccess(res))


  } catch (error) {
    yield put(updateContactTypeFail(error))
  }
}


//Lead Classification

function* submitLeadClass({ payload: { leadclass, history } }) {
  try {

    toast.loading("Please wait...")
    const response = yield call(postLeadClassificationAPI, {
      leadClassificationTitle:leadclass.leadClassificationTitle,
      agentId: parseInt(localStorage.getItem('userId'))
    })
    yield put(addLeadClassificationSuccess(response))
    if (response.success == true) {
      toast.dismiss();
      toast.success("Saved Successfully");
      const response = yield call(getLeadClassificatioAPI, parseInt(localStorage.getItem('userId')))
      yield put(getLeadClassificationSuccess(response))
    } else {
      toast.dismiss();
      toast.warn(response.validationErrors[0]);
    }
  }
  catch (error) {

    yield put(addLeadClassificationError('Some Error'))
  }
}

function* fetchLeadClass({ agentId }) {
  try {
    const response = yield call(getLeadClassificatioAPI, agentId)
    yield put(getLeadClassificationSuccess(response))
  } catch (error) {
    yield put(getLeadClassificationFail(error))
  }
}

function* onDeleteLeadClass({ payload: leadclass }) {
  try {
    toast.loading("Please wait...")
    const response = yield call(deleteLeadClassificatioAPI, leadclass.id)
    yield put(deleteLeadClassificationSuccess(response))
    toast.dismiss();
    toast.success("Deleted Successfully");
    const res = yield call(getLeadClassificatioAPI, leadclass.agentId)
    yield put(getLeadClassificationSuccess(res))

  } catch (error) {
    yield put(deleteLeadClassificationFail(error))
  }
}

function* onUpdateLeadClass({ payload: leadclass }) {
  try {
    toast.loading("Please wait...")
    const response = yield call(updateLeadClassificatioAPI, leadclass)
    toast.dismiss();
    toast.success("Updated successfully");
    const res = yield call(getLeadClassificatioAPI, leadclass.agentId)
    yield put(getLeadClassificationSuccess(res))


  } catch (error) {
    yield put(updateLeadClassficationFail(error))
  }
}


//Lead Source

function* submitLeadSource({ payload: { leadsource, history } }) {
  try {

    toast.loading("Please wait...")
    const response = yield call(postLeadSourceAPI, {
      leadSourceTitle:leadsource.leadSourceTitle,
      agentId: parseInt(localStorage.getItem('userId'))
    })
    yield put(addLeadSourceSuccess(response))
    if (response.success == true) {
      toast.dismiss();
      toast.success("Saved successfully");
      const response = yield call(getLeadSourceAPI, parseInt(localStorage.getItem('userId')))
      yield put(getLeadSourceSuccess(response))
    } else {
      toast.dismiss();
      toast.warn(response.validationErrors[0]);
    }
  }
  catch (error) {

    yield put(addLeadSourceError('Some Error'))
  }
}

function* fetchLeadSource({ agentId }) {
  try {
    const response = yield call(getLeadSourceAPI, agentId)
    yield put(getLeadSourceSuccess(response))
  } catch (error) {
    yield put(getLeadSourceFail(error))
  }
}

function* onDeleteLeadSource({ payload: leadsource }) {
  try {
    toast.loading("Please wait...")
    const response = yield call(deleteLeadSourceAPI, leadsource.id)
    yield put(deleteLeadSourceSuccess(response))
    toast.dismiss();
    toast.success("Deleted successfully");
    const res = yield call(getLeadSourceAPI, leadsource.agentId)
    yield put(getLeadSourceSuccess(res))

  } catch (error) {
    yield put(deleteLeadSourceFail(error))
  }
}

function* onUpdateLeadSource({ payload: leadsource }) {
  try {
    toast.loading("Please wait...")
    const response = yield call(updateLeadSourceAPI, leadsource)
    toast.dismiss();
    toast.success("Updated sccessfully");
    const res = yield call(getLeadSourceAPI, leadsource.agentId)
    yield put(getLeadSourceSuccess(res))


  } catch (error) {
    yield put(updateLeadSourceFail(error))
  }
}


//Lead Status

function* submitLeadStatus({ payload: { leadstatus, history } }) {
  try {

    toast.loading("Please wait...")
    const response = yield call(postLeadStatusAPI, {
      leadStatusTitle:leadstatus.leadStatusTitle,
      agentId: parseInt(localStorage.getItem('userId'))
    })
    yield put(addLeadStatusSuccess(response))
    if (response.success == true) {
      toast.dismiss();
      toast.success("Saved successfully");
      const response = yield call(getLeadStatusAPI, parseInt(localStorage.getItem('userId')))
      yield put(getLeadStatusSuccess(response))
    } else {
      toast.dismiss();
      toast.warn(response.validationErrors[0]);
    }
  }
  catch (error) {

    yield put(addLeadStatusError('Some Error'))
  }
}

function* fetchLeadStatus({ agentId }) {
  try {
    const response = yield call(getLeadStatusAPI, agentId)
    yield put(getLeadStatusSuccess(response))
  } catch (error) {
    yield put(getLeadStatusFail(error))
  }
}

function* onDeleteLeadStatus({ payload: leadstatus }) {
  try {
    toast.loading("Please wait...")
    const response = yield call(deleteLeadStatusAPI, leadstatus.id)
    yield put(deleteLeadStatusSuccess(response))
    toast.dismiss();
    toast.success("Deleted successfully");
    const res = yield call(getLeadStatusAPI, leadstatus.agentId)
    yield put(getLeadStatusSuccess(res))

  } catch (error) {
    yield put(deleteLeadStatusFail(error))
  }
}

function* onUpdateLeadStatus({ payload: leadstatus }) {
  try {
    toast.loading("Please wait...")
    const response = yield call(updateLeadStatusAPI, leadstatus)
    toast.dismiss();
    toast.success("Updated successfully");
    const res = yield call(getLeadStatusAPI, leadstatus.agentId)
    yield put(getLeadStatusSuccess(res))


  } catch (error) {
    yield put(updateLeadStatusFail(error))
  }
}




function* submitLeadType({ payload: { leadtype, history } }) {
  try {

    toast.loading("Please wait...")
    const response = yield call(postLeadTypeAPI, {
      leadTypeTitle:leadtype.leadTypeTitle,
      agentId: parseInt(localStorage.getItem('userId'))
    })
    yield put(addLeadTypeSuccess(response))
    if (response.success == true) {
      toast.dismiss();
      toast.success("Saved successfully");
      const response = yield call(getLeadTypeAPI, parseInt(localStorage.getItem('userId')))
      yield put(getLeadTypeSuccess(response))
    } else {
      toast.dismiss();
      toast.warn(response.validationErrors[0]);
    }
  }
  catch (error) {

    yield put(addLeadTypeError('Some Error'))
  }
}

function* fetchLeadType({ agentId }) {
  try {
    const response = yield call(getLeadTypeAPI, agentId)
    yield put(getLeadTypeSuccess(response))
  } catch (error) {
    yield put(getLeadStatusFail(error))
  }
}

function* onDeleteLeadType({ payload: leadtype }) {
  try {
    toast.loading("Please wait...")
    const response = yield call(deleteLeadTypeAPI, leadtype.id)
    yield put(deleteLeadTypeSuccess(response))
    toast.dismiss();
    toast.success("Deleted successfully");
    const res = yield call(getLeadTypeAPI, leadtype.agentId)
    yield put(getLeadTypeSuccess(res))

  } catch (error) {
    yield put(deleteLeadTypeFail(error))
  }
}

function* onUpdateLeadType({ payload: leadtype }) {
  try {
    toast.loading("Please wait...")
    const response = yield call(updateLeadTypeAPI, leadtype)
    toast.dismiss();
    toast.success("Updated successfully");
    const res = yield call(getLeadTypeAPI, leadtype.agentId)
    yield put(getLeadTypeSuccess(res))


  } catch (error) {
    yield put(updateLeadTypeFail(error))
  }
}

//Note Type

function* submitNoteType({ payload: { notetype, history } }) {
  try {

    toast.loading("Please wait...")
    const response = yield call(postNoteTypeAPI, {
      noteTypeTitle:notetype.noteTypeTitle,
      agentId: parseInt(localStorage.getItem('userId'))
    })
    yield put(addNoteTypeSuccess(response))
    if (response.success == true) {
      toast.dismiss();
      toast.success("Saved successfully");
      const response = yield call(getNoteTypeAPI, parseInt(localStorage.getItem('userId')))
      yield put(getNoteTypeSuccess(response))
    } else {
      toast.dismiss();
      toast.warn(response.validationErrors[0]);
    }
  }
  catch (error) {

    yield put(addNoteTypeError('Some Error'))
  }
}

function* fetchNoteType({ agentId }) {
  try {
    const response = yield call(getNoteTypeAPI, agentId)
    yield put(getNoteTypeSuccess(response))
  } catch (error) {
    yield put(getNoteTypeFail(error))
  }
}

function* onDeleteNoteType({ payload: notetype }) {
  try {
    toast.loading("Please wait...")
    const response = yield call(deleteNoteTypeAPI, notetype.id)
    yield put(deleteNoteTypeSuccess(response))
    toast.dismiss();
    toast.success("Deleted successfully");
    const res = yield call(getNoteTypeAPI, notetype.agentId)
    yield put(getNoteTypeSuccess(res))

  } catch (error) {
    yield put(deleteNoteTypeFail(error))
  }
}

function* onUpdateNoteType({ payload: notetype }) {
  try {
    toast.loading("Please wait...")
    const response = yield call(updateNoteTypeAPI, notetype)
    toast.dismiss();
    toast.success("Updated successfully");
    const res = yield call(getNoteTypeAPI, notetype.agentId)
    yield put(getNoteTypeSuccess(res))


  } catch (error) {
    yield put(updateNoteTypeFail(error))
  }
}


//Project Document Types

function* submitProjectDocType({ payload: { doctype, history } }) {
  try {

    toast.loading("Please wait...")
    const response = yield call(postProjectDocTypeAPI, {
      projectDocumentTypeTitle:doctype.projectDocumentTypeTitle,
      agentId: parseInt(localStorage.getItem('userId'))
    })
    yield put(addProjectDocTypeSuccess(response))
    if (response.success == true) {
      toast.dismiss();
      toast.success("Saved successfully");
      const response = yield call(getProjectDocTypeAPI, parseInt(localStorage.getItem('userId')))
      yield put(getProjectDocTypeSuccess(response))
    } else {
      toast.dismiss();
      toast.warn(response.validationErrors[0]);
    }
  }
  catch (error) {

    yield put(addProjectDocTypeError('Some Error'))
  }
}

function* fetchProjectDocType({ agentId }) {
  try {
    const response = yield call(getProjectDocTypeAPI, agentId)
    yield put(getProjectDocTypeSuccess(response))
  } catch (error) {
    yield put(getProjectDocTypeFail(error))
  }
}

function* onDeleteProjectDocType({ payload: doctype }) {
  try {
    toast.loading("Please wait...")
    const response = yield call(deleteProjectDocTypeAPI, doctype.id)
    yield put(deleteProjectTypeSuccess(response))
    toast.dismiss();
    toast.success("Deleted successfully");
    const res = yield call(getProjectDocTypeAPI, doctype.agentId)
    yield put(getProjectDocTypeSuccess(res))

  } catch (error) {
    yield put(deleteProjectDocTypeFail(error))
  }
}

function* onUpdateProjectDocType({ payload: doctype }) {
  try {
    toast.loading("Please wait...")
    const response = yield call(updateProjectDocTypeAPI, doctype)
    toast.dismiss();
    toast.success("Updated successfully");
    const res = yield call(getProjectDocTypeAPI, doctype.agentId)
    yield put(getProjectDocTypeSuccess(res))


  } catch (error) {
    yield put(updateProjectDocTypeFail(error))
  }
}

//Project Status

function* submitProjectStatus({ payload: { docstatus, history } }) {
  try {

    toast.loading("Please wait...")
    const response = yield call(postProjectStatusAPI, {
      projectStatusTitle:docstatus.projectStatusTitle,
      agentId: parseInt(localStorage.getItem('userId'))
    })
    yield put(addProjectStatusSuccess(response))
    if (response.success == true) {
      toast.dismiss();
      toast.success("Saved successfully");
      const response = yield call(getProjectStatusAPI, parseInt(localStorage.getItem('userId')))
      yield put(getProjectStatusSuccess(response))
    } else {
      toast.dismiss();
      toast.warn(response.validationErrors[0]);
    }
  }
  catch (error) {

    yield put(addProjectStatusError('Some Error'))
  }
}

function* fetchProjectStatus({ agentId }) {
  try {
    const response = yield call(getProjectStatusAPI, agentId)
    yield put(getProjectStatusSuccess(response))
  } catch (error) {
    yield put(getProjectStatusFail(error))
  }
}

function* onDeleteProjectStatus({ payload: docstatus }) {
  try {
    toast.loading("Please wait...")
    const response = yield call(deleteProjectStatusAPI, docstatus.id)
    yield put(deleteProjectStatusSuccess(response))
    toast.dismiss();
    toast.success("Deleted successfully");
    const res = yield call(getProjectStatusAPI, docstatus.agentId)
    yield put(getProjectStatusSuccess(res))

  } catch (error) {
    yield put(deleteProjectStatusFail(error))
  }
}

function* onUpdateProjectStatus({ payload: docstatus }) {
  try {
    toast.loading("Please wait...")
    const response = yield call(updateProjectStatusAPI, docstatus)
    toast.dismiss();
    toast.success("Updated successfully");
    const res = yield call(getProjectStatusAPI, docstatus.agentId)
    yield put(getProjectStatusSuccess(res))


  } catch (error) {
    yield put(updateProjectStatusFail(error))
  }
}

//Project Type

function* submitProjectType({ payload: { protype, history } }) {
  try {

    toast.loading("Please wait...")
    const response = yield call(postProjectTypeAPI, {
      projectTypeTitle:protype.projectTypeTitle,
      agentId: parseInt(localStorage.getItem('userId'))
    })
    yield put(addProjectTypeSuccess(response))
    if (response.success == true) {
      toast.dismiss();
      toast.success("Saved successfully");
      const response = yield call(getProjectTypeAPI, parseInt(localStorage.getItem('userId')))
      yield put(getProjectTypeSuccess(response))
    } else {
      toast.dismiss();
      toast.warn(response.validationErrors[0]);
    }
  }
  catch (error) {

    yield put(addProjectTypeError('Some Error'))
  }
}

function* fetchProjectType({ agentId }) {
  try {
    const response = yield call(getProjectTypeAPI, agentId)
    yield put(getProjectTypeSuccess(response))
  } catch (error) {
    yield put(getProjectTypeFail(error))
  }
}

function* onDeleteProjectType({ payload: protype }) {
  try {
    toast.loading("Please wait...")
    const response = yield call(deleteProjectTypeAPI, protype.id)
    yield put(deleteProjectTypeSuccess(response))
    toast.dismiss();
    toast.success("Deleted successfully");
    const res = yield call(getProjectTypeAPI, protype.agentId)
    yield put(getProjectTypeSuccess(res))

  } catch (error) {
    yield put(deleteProjectTypeFail(error))
  }
}

function* onUpdateProjectType({ payload: protype }) {
  try {
    toast.loading("Please wait...")
    const response = yield call(updateProjectTypeAPI, protype)
    toast.dismiss();
    toast.success("Updated successfully");
    const res = yield call(getProjectTypeAPI, protype.agentId)
    yield put(getProjectTypeSuccess(res))


  } catch (error) {
    yield put(updateProjectTypeFail(error))
  }
}


//Service Type

function* submitServiceType({ payload: { sertype, history } }) {
  try {

    toast.loading("Please wait...")
    const response = yield call(postServiceTypeAPI, {
      serviceTypeTitle:sertype.serviceTypeTitle,
      agentId: parseInt(localStorage.getItem('userId'))
    })
    yield put(addServiceTypeSuccess(response))
    if (response.success == true) {
      toast.dismiss();
      toast.success("Saved successfully");
      const response = yield call(getServiceTypeAPI, parseInt(localStorage.getItem('userId')))
      yield put(getServiceTypeSuccess(response))
    } else {
      toast.dismiss();
      toast.warn(response.validationErrors[0]);
    }
  }
  catch (error) {

    yield put(addServiceTypeError('Some Error'))
  }
}

function* fetchServiceType({ agentId }) {
  try {
    const response = yield call(getServiceTypeAPI, agentId)
    yield put(getServiceTypeSuccess(response))
  } catch (error) {
    yield put(getServiceTypeFail(error))
  }
}

function* onDeleteServiceType({ payload: sertype }) {
  try {
    toast.loading("Please wait...")
    const response = yield call(deleteServiceTypeAPI, sertype.id)
    yield put(deleteServiceTypeSuccess(response))
    toast.dismiss();
    toast.success("Deleted successfully");
    const res = yield call(getServiceTypeAPI, sertype.agentId)
    yield put(getServiceTypeSuccess(res))

  } catch (error) {
    yield put(deleteServiceTypeFail(error))
  }
}

function* onUpdateServiceType({ payload: sertype }) {
  try {
    toast.loading("Please wait...")
    const response = yield call(updateServiceTypeAPI, sertype)
    toast.dismiss();
    toast.success("Updated successfully");
    const res = yield call(getServiceTypeAPI, sertype.agentId)
    yield put(getServiceTypeSuccess(res))


  } catch (error) {
    yield put(updateServiceTypeFail(error))
  }
}

//Task Priorities

function* submitTaskPriority({ payload: { taskpriority, history } }) {
  try {

    toast.loading("Please wait...")
    const response = yield call(postTaskPriorityAPI, {
      taskPriorityCode:taskpriority.taskPriorityCode,
      taskPriorityTitle:taskpriority.taskPriorityTitle,
      agentId: parseInt(localStorage.getItem('userId'))
    })
    yield put(addTaskPrioritySuccess(response))
    if (response.success == true) {
      toast.dismiss();
      toast.success("Saved Successfully");
      const response = yield call(getTaskPriorityAPI, parseInt(localStorage.getItem('userId')))
      yield put(getTaskPrioritySuccess(response))
    } else {
      toast.dismiss();
      toast.warn(response.validationErrors[0]);
    }
  }
  catch (error) {

    yield put(addTaskPriorityError('Some Error'))
  }
}

function* fetchTaskPriority({ agentId }) {
  try {
    const response = yield call(getTaskPriorityAPI, agentId)
    yield put(getTaskPrioritySuccess(response))
  } catch (error) {
    yield put(getTaskPriorityFail(error))
  }
}

function* onDeleteTaskPriority({ payload: taskpriority }) {
  try {
    toast.loading("Please wait...")
    const response = yield call(deleteTaskPriorityAPI, taskpriority.id)
    yield put(deleteTaskPrioritySuccess(response))
    toast.dismiss();
    toast.success("Deleted Successfully");
    const res = yield call(getTaskPriorityAPI, taskpriority.agentId)
    yield put(getTaskPrioritySuccess(res))

  } catch (error) {
    yield put(deleteTaskPriorityFail(error))
  }
}

function* onUpdateTaskPriority({ payload: taskpriority }) {
  try {
    toast.loading("Please wait...")
    const response = yield call(updateTaskPriorityAPI, taskpriority)
    toast.dismiss();
    toast.success("Updated Successfully");
    const res = yield call(getTaskPriorityAPI, taskpriority.agentId)
    yield put(getTaskPrioritySuccess(res))


  } catch (error) {
    yield put(updateTaskPriorityFail(error))
  }
}


//Task Reminder

function* submitTaskReminder({ payload: { taskreminder, history } }) {
  try {

    toast.loading("Please wait...")
    const response = yield call(postTaskReminderAPI, {
     
      taskReminderTitle:taskreminder.taskReminderTitle,
      agentId: parseInt(localStorage.getItem('userId'))
    })
    yield put(addTaskReminderSuccess(response))
    if (response.success == true) {
      toast.dismiss();
      toast.success("Added Successfully");
      const response = yield call(getTaskReminderAPI, parseInt(localStorage.getItem('userId')))
      yield put(getTaskReminderSuccess(response))
    } else {
      toast.dismiss();
      toast.warn(response.validationErrors[0]);
    }
  }
  catch (error) {

    yield put(addTaskReminderError('Some Error'))
  }
}

function* fetchTaskReminder({ agentId }) {
  try {
    const response = yield call(getTaskReminderAPI, agentId)
    yield put(getTaskReminderSuccess(response))
  } catch (error) {
    yield put(getTaskReminderFail(error))
  }
}

function* onDeleteTaskReminder({ payload: taskreminder }) {
  try {
    toast.loading("Please wait...")
    const response = yield call(deleteTaskReminderAPI, taskreminder.id)
    yield put(deleteTaskReminderSuccess(response))
    toast.dismiss();
    toast.success("Deleted Successfully");
    const res = yield call(getTaskReminderAPI, taskreminder.agentId)
    yield put(getTaskReminderSuccess(res))

  } catch (error) {
    yield put(deleteTaskReminderFail(error))
  }
}

function* onUpdateTaskReminder({ payload: taskreminder }) {
  try {
    toast.loading("Please wait...")
    const response = yield call(updateTaskReminderAPI, taskreminder)
    toast.dismiss();
    toast.success("Updated Successfully");
    const res = yield call(getTaskReminderAPI, taskreminder.agentId)
    yield put(getTaskReminderSuccess(res))


  } catch (error) {
    yield put(updateTaskReminderFail(error))
  }
}


//Task Status

function* submitTaskStatus({ payload: { taskstatus, history } }) {
  try {

    toast.loading("Please wait...")
    const response = yield call(postTaskStatusAPI, {
      taskStatusCode:taskstatus.taskStatusCode,
      taskStatusTitle:taskstatus.taskStatusTitle,
      agentId: parseInt(localStorage.getItem('userId'))
    })
    yield put(addTaskStatusSuccess(response))
    if (response.success == true) {
      toast.dismiss();
      toast.success("Saved Successfully");
      const response = yield call(getTaskStatusAPI, parseInt(localStorage.getItem('userId')))
      yield put(getTaskStatusSuccess(response))
    } else {
      toast.dismiss();
      toast.warn(response.validationErrors[0]);
    }
  }
  catch (error) {

    yield put(addTaskStatusError('Some Error'))
  }
}

function* fetchTaskStatus({ agentId }) {
  try {
    const response = yield call(getTaskStatusAPI, agentId)
    yield put(getTaskStatusSuccess(response))
  } catch (error) {
    yield put(getTaskStatusFail(error))
  }
}

function* onDeleteTaskStatus({ payload: taskstatus }) {
  try {
    toast.loading("Please wait...")
    const response = yield call(deleteTaskStatusAPI, taskstatus.id)
    yield put(deleteTaskStatusSuccess(response))
    toast.dismiss();
    toast.success("Deleted Successfully");
    const res = yield call(getTaskStatusAPI, taskstatus.agentId)
    yield put(getTaskStatusSuccess(res))

  } catch (error) {
    yield put(deleteTaskStatusFail(error))
  }
}

function* onUpdateTaskStatus({ payload: taskstatus }) {
  try {
    toast.loading("Please wait...")
    const response = yield call(updateTaskStatusAPI, taskstatus)
    toast.dismiss();
    toast.success("Updated Successfully");
    const res = yield call(getTaskStatusAPI, taskstatus.agentId)
    yield put(getTaskStatusSuccess(res))


  } catch (error) {
    yield put(updateTaskStatusFail(error))
  }
}


//Task Type

function* submitTaskType({ payload: { tasktype, history } }) {
  try {

    toast.loading("Please wait...")
    const response = yield call(postTaskTypeAPI, {
      taskTypeTitle:tasktype.taskTypeTitle,
      agentId: parseInt(localStorage.getItem('userId'))
    })
    yield put(addTaskTypeSuccess(response))
    if (response.success == true) {
      toast.dismiss();
      toast.success("Saved Successfully");
      const response = yield call(getTaskTypeAPI, parseInt(localStorage.getItem('userId')))
      yield put(getTaskTypeSuccess(response))
    } else {
      toast.dismiss();
      toast.warn(response.validationErrors[0]);
    }
  }
  catch (error) {

    yield put(addTaskTypeError('Some Error'))
  }
}

function* fetchTaskType({ agentId }) {
  try {
    const response = yield call(getTaskTypeAPI, agentId)
    yield put(getTaskTypeSuccess(response))
  } catch (error) {
    yield put(getTaskTypeFail(error))
  }
}

function* onDeleteTaskType({ payload: tasktype }) {
  try {
    toast.loading("Please wait...")
    const response = yield call(deleteTaskTypeAPI, tasktype.id)
    yield put(deleteTaskTypeSuccess(response))
    toast.dismiss();
    toast.success("Deleted Successfully");
    const res = yield call(getTaskTypeAPI, tasktype.agentId)
    yield put(getTaskTypeSuccess(res))

  } catch (error) {
    yield put(deleteTaskTypeFail(error))
  }
}

function* onUpdateTaskType({ payload: tasktype }) {
  try {
    toast.loading("Please wait...")
    const response = yield call(updateTaskTypeAPI, tasktype)
    toast.dismiss();
    toast.success("Updated Successfully");
    const res = yield call(getTaskTypeAPI, tasktype.agentId)
    yield put(getTaskTypeSuccess(res))


  } catch (error) {
    yield put(updateTaskTypeFail(error))
  }
}

//Lead Source

function* submitLeadStage({ payload: { leadstage, history } }) {
  try {

    toast.loading("Please wait...")
    const response = yield call(postLeadStageAPI, {
      leadStageTitle:leadstage.leadStageTitle,
      agentId: parseInt(localStorage.getItem('userId'))
    })
    yield put(addLeadStageSuccess(response))
    if (response.success == true) {
      toast.dismiss();
      toast.success("Saved Successfully");
      const response = yield call(getLeadStageAPI, parseInt(localStorage.getItem('userId')))
      yield put(getLeadStageSuccess(response))
    } else {
      toast.dismiss();
      toast.warn(response.validationErrors[0]);
    }
  }
  catch (error) {

    yield put(addLeadStageError('Some Error'))
  }
}

function* fetchLeadStage({ agentId }) {
  try {
    const response = yield call(getLeadStageAPI, agentId)
    yield put(getLeadStageSuccess(response))
  } catch (error) {
    yield put(getLeadStageFail(error))
  }
}

function* onDeleteLeadStage({ payload: leadstage }) {
  try {
    toast.loading("Please wait...")
    const response = yield call(deleteLeadStageAPI, leadstage.id)
    yield put(deleteLeadStageSuccess(response))
    toast.dismiss();
    toast.success("Deleted Successfully");
    const res = yield call(getLeadStageAPI, leadstage.agentId)
    yield put(getLeadStageSuccess(res))

  } catch (error) {
    yield put(deleteLeadStageFail(error))
  }
}

function* onUpdateLeadStage({ payload: leadstage }) {
  try {
    toast.loading("Please wait...")
    const response = yield call(updateLeadStageAPI, leadstage)
    toast.dismiss();
    toast.success("Updated Successfully");
    const res = yield call(getLeadStageAPI, leadstage.agentId)
    yield put(getLeadStageSuccess(res))


  } catch (error) {
    yield put(updateLeadStageFail(error))
  }
}

//Transaction Type
function* submitTransType({ payload: { transactonType, history } }) {
  try {

    toast.loading("Please wait...")
    const response = yield call(postTransactionTypeAPI, {
     
      title:transactonType.title,
      agentId: parseInt(localStorage.getItem('userId'))
    })
    yield put(addTransTypeSuccess(response))
    if (response.success == true) {
      toast.dismiss();
      toast.success("Saved Successfully");
      const response = yield call(getTransactionTypeAPI, parseInt(localStorage.getItem('userId')))
      yield put(getTransTypeSuccess(response))
    } else {
      toast.dismiss();
      toast.warn(response.validationErrors[0]);
    }
  }
  catch (error) {

    yield put(addTransTypeError('Some Error'))
  }
}

function* fetchTransType({ agentId }) {
  try {
    const response = yield call(getTransactionTypeAPI, agentId)
    yield put(getTransTypeSuccess(response))
  } catch (error) {
    yield put(getTransTypeFail(error))
  }
}

function* onDeleteTransType({ payload: transactonType }) {
  try {
    toast.loading("Please wait...")
    const response = yield call(deleteTransactionTypeAPI, transactonType.id)
    yield put(deleteTransTypeSuccess(response))
    toast.dismiss();
    toast.success("Deleted successfully");
    const res = yield call(getTransactionTypeAPI, transactonType.agentId)
    yield put(getTransTypeSuccess(res))

  } catch (error) {
    yield put(deleteTransTypeFail(error))
  }
}

function* onUpdateTransType({ payload: transactonType }) {
  try {
    toast.loading("Please wait...")
    const response = yield call(updateTransactionTypeAPI, transactonType)
    toast.dismiss();
    toast.success("Updated Successfully");
    const res = yield call(getTransactionTypeAPI, transactonType.agentId)
    yield put(getTransTypeSuccess(res))


  } catch (error) {
    yield put(updateTransTypeFail(error))
  }
}


//Transaction Comm Type
function* submitTransCommType({ payload: { commTransType, history } }) {
  try {

    toast.loading("Please wait...")
    const response = yield call(postTransactionCommAPI, {
     
      title:commTransType.title,
      agentId: parseInt(localStorage.getItem('userId'))
    })
    yield put(addTransCommTypeSuccess(response))
    if (response.success == true) {
      toast.dismiss();
      toast.success("Saved Successfully");
      const response = yield call(getTransactionCommAPI, parseInt(localStorage.getItem('userId')))
      yield put(getTransCommTypeSuccess(response))
    } else {
      toast.dismiss();
      toast.warn(response.validationErrors[0]);
    }
  }
  catch (error) {

    yield put(addTransCommTypeError('Some Error'))
  }
}

function* fetchTransCommType({ agentId }) {
  try {
    const response = yield call(getTransactionCommAPI, agentId)
    yield put(getTransCommTypeSuccess(response))
  } catch (error) {
    yield put(getTransCommTypeFail(error))
  }
}

function* onDeleteTransCommType({ payload: transactionCommType }) {
  try {
    toast.loading("Please wait...")
    const response = yield call(deleteTransactionCommAPI, transactionCommType.id)
    yield put(deleteTransCommTypeSuccess(response))
    toast.dismiss();
    toast.success("Deleted Successfully");
    const res = yield call(getTransactionCommAPI, transactionCommType.agentId)
    yield put(getTransCommTypeSuccess(res))

  } catch (error) {
    yield put(deleteTransCommTypeSuccess(error))
  }
}

function* onUpdateTransCommType({ payload: transactionCommType }) {
  try {
    toast.loading("Please wait...")
    const response = yield call(updateTransactionCommAPI, transactionCommType)
    toast.dismiss();
    toast.success("Updated Successfully");
    const res = yield call(getTransactionCommAPI, transactionCommType.agentId)
    yield put(getTransCommTypeSuccess(res))


  } catch (error) {
    yield put(updateTransCommTypeFail(error))
  }
}


//Transaction Ref Type
function* submitTransRefType({ payload: { refTransType, history } }) {
  try {

    toast.loading("Please wait...")
    const response = yield call(postTransactionRefAPI, {
     
      title:refTransType.title,
      agentId: parseInt(localStorage.getItem('userId'))
    })
    yield put(addTransCommTypeSuccess(response))
    if (response.success == true) {
      toast.dismiss();
      toast.success("Saved Successfully");
      const response = yield call(getTransactionRefAPI, parseInt(localStorage.getItem('userId')))
      yield put(getTransRefTypeSuccess(response))
    } else {
      toast.dismiss();
      toast.warn(response.validationErrors[0]);
    }
  }
  catch (error) {

    yield put(addTransRefTypeError('Some Error'))
  }
}

function* fetchTransRefType({ agentId }) {
  try {
    const response = yield call(getTransactionRefAPI, agentId)
    yield put(getTransRefTypeSuccess(response))
  } catch (error) {
    yield put(getTransRefTypeFail(error))
  }
}

function* onDeleteTransRefType({ payload: transactonRefType }) {
  try {
    toast.loading("Please wait...")
    const response = yield call(deleteTransactionRefAPI, transactonRefType.id)
    yield put(deleteTransCommTypeSuccess(response))
    toast.dismiss();
    toast.success("Deleted Successfully");
    const res = yield call(getTransactionRefAPI, transactonRefType.agentId)
    yield put(getTransRefTypeSuccess(res))

  } catch (error) {
    yield put(deleteTransCommTypeFail(error))
  }
}

function* onUpdateTransRefType({ payload: transactonRefType }) {
  try {
    toast.loading("Please wait...")
    const response = yield call(updateTransactionRefAPI, transactonRefType)
    toast.dismiss();
    toast.success("Updated Successfully");
    const res = yield call(getTransactionRefAPI, transactonRefType.agentId)
    yield put(getTransRefTypeSuccess(res))


  } catch (error) {
    yield put(updateTransRefTypeFail(error))
  }
}


//Transaction Status Type
function* submitTransStatusType({ payload: { transStatusType, history } }) {
  try {

    toast.loading("Please wait...")
    const response = yield call(postTransactionStatusAPI, {
     
      title:transStatusType.title,
      agentId: parseInt(localStorage.getItem('userId'))
    })
    yield put(addTransStatusTypeSuccess(response))
    if (response.success == true) {
      toast.dismiss();
      toast.success("Saved Successfully");
      const response = yield call(getTransactionStatusAPI, parseInt(localStorage.getItem('userId')))
      yield put(getTransStatusTypeSuccess(response))
    } else {
      toast.dismiss();
      toast.warn(response.validationErrors[0]);
    }
  }
  catch (error) {

    yield put(addTransStatusTypeError('Some Error'))
  }
}

function* fetchTransStatusType({ payload:{ agentId, forType} }) {
  try {
    const response = yield call(getTransactionStatusAPI, agentId, forType)
    yield put(getTransStatusTypeSuccess(response))
  } catch (error) {
    yield put(getTransStatusTypeFail(error))
  }
}

function* onDeleteTransStatusType({ payload: transStatusType }) {
  try {
    toast.loading("Please wait...")
    const response = yield call(deleteTransactionStatusAPI, transStatusType.id)
    yield put(deleteTransStatusTypeSuccess(response))
    toast.dismiss();
    toast.success("Deleted Successfully");
    const res = yield call(getTransactionStatusAPI, transStatusType.agentId)
    yield put(getTransStatusTypeSuccess(res))

  } catch (error) {
    yield put(deleteTransStatusTypeFail(error))
  }
}

function* onUpdateTransStatusType({ payload: transStatusType }) {
  try {
    toast.loading("Please wait...")
    const response = yield call(updateTransactionStatusAPI, transStatusType)
    toast.dismiss();
    toast.success("Updated Successfully");
    const res = yield call(getTransactionRefAPI, transStatusType.agentId)
    yield put(getTransStatusTypeSuccess(res))


  } catch (error) {
    yield put(updateTransStatusTypeFail(error))
  }
}


function* submitListingType({ payload: { listingtype, history } }) {
  try {

    toast.loading("Please wait...")
    const response = yield call(postListingTypeApi, listingtype)
    yield put(addListingTypeSuccess(response))
    if (response.success == true) {
      toast.dismiss();
      toast.success("Saved Successfully");
      const response = yield call(getListingTypeApi, parseInt(localStorage.getItem('userId')))
      yield put(getListingTypeSuccess(response))
    } else {
      toast.dismiss();
      toast.warn(response.validationErrors[0]);
    }
  }
  catch (error) {

    yield put(addListingTypeError('Some Error'))
  }
}

function* fetchListingType({ agentId }) {
  try {
    const response = yield call(getListingTypeApi, agentId)
    yield put(getListingTypeSuccess(response))
  } catch (error) {
    yield put(getListingTypeFail(error))
  }
}

function* onDeleteListingType({ payload: listingtype }) {
  try {
    toast.loading("Please wait...")
    const response = yield call(deleteListingTypeApi, listingtype.id)
    yield put(deleteListingTypeSuccess(response))
    toast.dismiss();
    toast.success("Deleted Successfully");
    const res = yield call(getListingTypeApi, listingtype.agentId)
    yield put(getListingTypeSuccess(res))

  } catch (error) {
    yield put(deleteListingTypeFail(error))
  }
}

function* onUpdateListingType({ payload: listingtype }) {
  try {
    toast.loading("Please wait...")
    const response = yield call(updateListingTypeApi, listingtype)
    toast.dismiss();
    toast.success("Updated Successfully");
    const res = yield call(getListingTypeApi, listingtype.agentId)
    yield put(getListingTypeSuccess(res))


  } catch (error) {
    yield put(updateListingTypeFail(error))
  }
}


function* submitListingStatus({ payload: { listingstatus, history } }) {
  try {

    toast.loading("Please wait...")
    const response = yield call(postListingStatusApi, listingstatus)
    yield put(addListingStatusSuccess(response))
    if (response.success == true) {
      toast.dismiss();
      toast.success("Saved Successfully");
      const response = yield call(getListingStatusApi, parseInt(localStorage.getItem('userId')))
      yield put(getListingStatusSuccess(response))
    } else {
      toast.dismiss();
      toast.warn(response.validationErrors[0]);
    }
  }
  catch (error) {

    yield put(addListingStatusError('Some Error'))
  }
}

function* fetchListingStatus({ agentId }) {
  try {
    const response = yield call(getListingStatusApi, agentId)
    yield put(getListingStatusSuccess(response))
  } catch (error) {
    yield put(getListingStatusFail(error))
  }
}

function* onDeleteListingStatus({ payload: listingstatus }) {
  try {
    toast.loading("Please wait...")
    const response = yield call(deleteListingStatusApi, listingstatus.id)
    yield put(deleteListingStatusSuccess(response))
    toast.dismiss();
    toast.success("Deleted Successfully");
    const res = yield call(getListingStatusApi, listingstatus.agentId)
    yield put(getListingStatusSuccess(res))

  } catch (error) {
    yield put(deleteListingStatusFail(error))
  }
}

function* onUpdateListingStatus({ payload: listingstatus }) {
  try {
    toast.loading("Please wait...")
    const response = yield call(updateListingStatusApi, listingstatus)
    toast.dismiss();
    toast.success("Updated Successfully");
    const res = yield call(getListingStatusApi, listingstatus.agentId)
    yield put(getListingStatusSuccess(res))


  } catch (error) {
    yield put(updateListingStatusFail(error))
  }
}

function* submitShowingStatus({ payload: { showingstatus, history } }) {
  try {

    toast.loading("Please wait...")
    const response = yield call(postShowingStatusApi, showingstatus)
    yield put(addShowingStatusSuccess(response))
    if (response.success == true) {
      toast.dismiss();
      toast.success("Saved Successfully");
      const response = yield call(getShowingStatusApi, parseInt(localStorage.getItem('userId')))
      yield put(getShowingStatusSuccess(response))
    } else {
      toast.dismiss();
      toast.warn(response.validationErrors[0]);
    }
  }
  catch (error) {

    yield put(addShowingStatusError('Some Error'))
  }
}

function* onDeleteShowingStatus({ payload: showingstatus }) {
  try {
    toast.loading("Please wait...")
    const response = yield call(deleteShowingStatusApi, showingstatus.id)
    yield put(deleteShowingStatusSuccess(response))
    toast.dismiss();
    toast.success("Deleted Successfully");
    const res = yield call(getShowingStatusApi, showingstatus.agentId)
    yield put(getShowingStatusSuccess(res))

  } catch (error) {
    yield put(deleteShowingStatusFail(error))
  }
}


function* fetchShowingStatus({ agentId }) {
  try {
    const response = yield call(getShowingStatusApi, agentId)
    yield put(getShowingStatusSuccess(response))
  } catch (error) {
    yield put(getShowingStatusFail(error))
  }
}


function* onUpdateShowingStatus({ payload: showingstatus }) {
  try {
    toast.loading("Please wait...")
    const response = yield call(updateShowingStatusApi, showingstatus)
    toast.dismiss();
    toast.success("Updated Successfully");
    const res = yield call(getShowingStatusApi, showingstatus.agentId)
    yield put(getShowingStatusSuccess(res))


  } catch (error) {
    yield put(updateShowingStatusFail(error))
  }
}


function* submitEmailListType({  emaillisttype  }) {
  try {
   
    toast.loading("Please wait...")
    const response = yield call(postEmailListTypeApi, emaillisttype)
    yield put(addEmailListTypeSuccess(response))
    if (response.success == true) {
      toast.dismiss();
      toast.success("Saved Successfully");
      const response = yield call(getEmailListTypeApi, parseInt(localStorage.getItem('userId')))
      yield put(getEmailListTypeSuccess(response))
    } else {
      toast.dismiss();
      toast.warn(response.validationErrors[0]);
    }
  }
  catch (error) {

    yield put(addEmailListTypeError('Some Error'))
  }
}

function* fetchEmailListType({ agentId }) {
  try {
    const response = yield call(getEmailListTypeApi, agentId)
    yield put(getEmailListTypeSuccess(response))
  } catch (error) {
    yield put(getEmailListTypeFail(error))
  }
}


function* onUpdateEmailListType({ payload: emaillisttype }) {
  try {
    toast.loading("Please wait...")
    const response = yield call(updateEmailListTypeApi, emaillisttype)
    toast.dismiss();
    toast.success("Updated Successfully");
    const res = yield call(getEmailListTypeApi, emaillisttype.agentId)
    yield put(getEmailListTypeSuccess(res))


  } catch (error) {
    yield put(updateEmailListTypeFail(error))
  }
}

function* onDeleteEmailListType({ payload: emaillisttype }) {
  try {
    toast.loading("Please wait...")
    const response = yield call(deleteEmailListTypeApi, emaillisttype.id)
    yield put(deleteEmailListTypeSuccess(response))
    toast.dismiss();
    toast.success("Deleted Successfully");
    const res = yield call(getEmailListTypeApi, emaillisttype.agentId)
    yield put(getEmailListTypeSuccess(res))

  } catch (error) {
    yield put(deleteEmailListTypeFail(error))
  }
}


function* submitEmailListTarget({  emaillisttarget  }) {
  try {
    
    toast.loading("Please wait...")
    const response = yield call(postEmailListTargetApi, emaillisttarget)
    yield put(addEmailListTargetSuccess(response))
    if (response.success == true) {
      toast.dismiss();
      toast.success("Saved Successfully");
      const response = yield call(getEmailListTargetApi, parseInt(localStorage.getItem('userId')))
      yield put(getEmailListTargetSuccess(response))
    } else {
      toast.dismiss();
      toast.warn(response.validationErrors[0]);
    }
  }
  catch (error) {

    yield put(addEmailListTargetError('Some Error'))
  }
}

function* fetchEmailListTarget({ agentId }) {
  try {
    const response = yield call(getEmailListTargetApi, agentId)
    yield put(getEmailListTargetSuccess(response))
  } catch (error) {
    yield put(getEmailListTargetFail(error))
  }
}

function* onUpdateEmailListTarget({ payload: emaillisttarget }) {
  try {
    toast.loading("Please wait...")
    const response = yield call(updateEmailListTargetApi, emaillisttarget)
    toast.dismiss();
    toast.success("Updated Successfully");
    const res = yield call(getEmailListTargetApi, emaillisttarget.agentId)
    yield put(getEmailListTargetSuccess(res))


  } catch (error) {
    yield put(updateEmailListTargetFail(error))
  }
}

function* onDeleteEmailListTarget({ payload: emaillisttarget }) {
  try {
    toast.loading("Please wait...")
    const response = yield call(deleteEmailListTargetApi, emaillisttarget.id)
    yield put(deleteEmailListTargetSuccess(response))
    toast.dismiss();
    toast.success("Deleted Successfully");
    const res = yield call(getEmailListTargetApi, emaillisttarget.agentId)
    yield put(getEmailListTargetSuccess(res))

  } catch (error) {
    yield put(deleteEmailListTargetFail(error))
  }
}


function* submitCampaignEmailList_old({  campaignemaillist  }) {
  try {
    
    toast.loading("Please wait...")
    const response = yield call(postCampaignEmailListApi, campaignemaillist)
    yield put(addCampaignEmailListSuccess(response))
    if (response.success == true) {
      toast.dismiss();
      toast.success("Saved Successfully");
      const response = yield call(getCampaignEmailListApi, parseInt(localStorage.getItem('userId')))
      yield put(getCampaignEmailListSuccess(response))
    } else {
      toast.dismiss();
      toast.warn(response.validationErrors[0]);
    }
  }
  catch (error) {

    yield put(addCampaignEmailListError('Some Error'))
  }
}
function* submitCampaignEmailList({ payload: { campaignemaillist, callback } }) {
  let toastId;
  try {
    toastId = toast.loading("Please wait...");
    const response = yield call(postCampaignEmailListApi, campaignemaillist);
    yield put(addCampaignEmailListSuccess(response));

    if (response.success === true) {
      toast.update(toastId, {
        render: "Saved successfully",
        type: "success",
        isLoading: false,
        autoClose: 3000
      });

      const listResponse = yield call(getCampaignEmailListApi, parseInt(localStorage.getItem('userId')));
      yield put(getCampaignEmailListSuccess(listResponse));

      if (callback) callback(true); 
    } else {
      toast.update(toastId, {
        render: response.validationErrors?.[0] || "Something went wrong",
        type: "warning",
        isLoading: false,
        autoClose: 4000
      });

      if (callback) callback(false); 
    }
  } catch (error) {
    yield put(addCampaignEmailListError('Some Error'));

    toast.update(toastId, {
      render: "An error occurred",
      type: "error",
      isLoading: false,
      autoClose: 4000
    });

    if (callback) callback(false); 
  }
}

function* fetchCampaignEmailList({ agentId }) {
  try {
    const response = yield call(getCampaignEmailListApi, agentId)
    yield put(getCampaignEmailListSuccess(response))
  } catch (error) {
    yield put(getCampaignEmailListError(error))
  }
}

function* onUpdateCampaignEmailList({ payload: campaignemaillist }) {
  try {
    toast.loading("Please wait...")
    const response = yield call(updateCampaignEmailListApi, campaignemaillist)
    toast.dismiss();
    toast.success("Updated successfully");
    const res = yield call(getCampaignEmailListApi, campaignemaillist.agentId)
    yield put(getCampaignEmailListSuccess(res))


  } catch (error) {
    yield put(updateCampaignEmailListFail(error))
  }
}

function* onDeleteCampaignEmailList({ payload: campaignemaillist }) {
  try {
    toast.loading("Please wait...")
    const response = yield call(deleteCampaignEmailListApi, campaignemaillist.id)
    yield put(deleteEmailListTargetSuccess(response))
    toast.dismiss();
    toast.success("Deleted Successfully");
    const res = yield call(getCampaignEmailListApi, campaignemaillist.agentId)
    yield put(getCampaignEmailListSuccess(res))

  } catch (error) {
    yield put(deleteEmailListTargetFail(error))
  }
}

function* fetchAppByPageType({ payload:{ leadId, pageType} }) {
  try {
   
    const response = yield call(leadAppDetailApi, leadId)
    yield put(getAppDetailByIdSuccess(response))
  
  } catch (error) {
    yield put(getAppDetailByIdFail(error))
  }
}

function* onUpdateCalendarApp({ payload: appointment }) {
  try {
    toast.loading("Please wait...")
    const response = yield call(updateCalAppApi, appointment)
    toast.dismiss();
    toast.success("Updated Successfully");
  } catch (error) {
    yield put(updateCampaignEmailListFail(error))
  }
}

function* onDeleteCalendarApp({ payload: appointment }) {
  try {
    toast.loading("Please wait...")
    const response = yield call(deleteCalAppApi, appointment.id)
    yield put(deleteCalendarAppSuccess(response))
    toast.dismiss();
    toast.success("Deleted Successfully");
  } catch (error) {
    yield put(deleteCalendarAppFail(error))
  }
}


function* ObjectSaga() {
  yield takeEvery(ADD_APPOINTMENT_LOCATION_TYPE, submitAppLocationType)
  yield takeEvery(GET_APPOINTMENT_LOCATION_TYPE, fetchAppLocationType)
  yield takeEvery(DELETE_APPOINTMENT_LOCATION_TYPE, onDeleteAppLocationType)
  yield takeEvery(UPDATE_APPOINTMENT_LOCATION_TYPE, onUpdateLocationType)

  yield takeEvery(ADD_APPOINTMENT_PRIORITY, submitAppPriority)
  yield takeEvery(GET_APPOINTMENT_PRIORITY, fetchAppPriority)
  yield takeEvery(DELETE_APPOINTMENT_PRIORITY, onDeleteAppPriority)
  yield takeEvery(UPDATE_APPOINTMENT_PRIORITY, onUpdateAppPriority)

  yield takeEvery(ADD_APPOINTMENT_TYPE, submitAppType)
  yield takeEvery(GET_APPOINTMENT_TYPE, fetchAppType)
  yield takeEvery(DELETE_APPOINTMENT_TYPE, onDeleteAppType)
  yield takeEvery(UPDATE_APPOINTMENT_TYPE, onUpdateAppType)

  yield takeEvery(ADD_CONTACT_LEVEL, submitContactLevel)
  yield takeEvery(GET_CONTACT_LEVEL, fetchContactLevel)
  yield takeEvery(DELETE_CONTACT_LEVEL, onDeleteContactLevel)
  yield takeEvery(UPDATE_CONTACT_LEVEL, onUpdateContactLevel)

  yield takeEvery(ADD_CONTACT_STATUS, submitContactStatus)
  yield takeEvery(GET_CONTACT_STATUS, fetchContactStatus)
  yield takeEvery(DELETE_CONTACT_STATUS, onDeleteContactStatus)
  yield takeEvery(UPDATE_CONTACT_STATUS, onUpdateContactStatus)

  yield takeEvery(ADD_CONTACT_TYPE, submitContactType)
  yield takeEvery(GET_CONTACT_TYPE, fetchContactType)
  yield takeEvery(DELETE_CONTACT_TYPE, onDeleteContactType)
  yield takeEvery(UPDATE_CONTACT_TYPE, onUpdateContactType)

  yield takeEvery(ADD_LEAD_CLASSIFICATION, submitLeadClass)
  yield takeEvery(GET_LEAD_CLASSIFICATION, fetchLeadClass)
  yield takeEvery(DELETE_LEAD_CLASSIFICATION, onDeleteLeadClass)
  yield takeEvery(UPDATE_LEAD_CLASSIFICATION, onUpdateLeadClass)

  yield takeEvery(ADD_LEAD_SOURCE, submitLeadSource)
  yield takeEvery(GET_LEAD_SOURCE, fetchLeadSource)
  yield takeEvery(DELETE_LEAD_SOURCE, onDeleteLeadSource)
  yield takeEvery(UPDATE_LEAD_SOURCE, onUpdateLeadSource)

  yield takeEvery(ADD_LEAD_STAGE, submitLeadStage)
  yield takeEvery(GET_LEAD_STAGE, fetchLeadStage)
  yield takeEvery(DELETE_LEAD_STAGE, onDeleteLeadStage)
  yield takeEvery(UPDATE_LEAD_STAGE, onUpdateLeadStage)

  yield takeEvery(ADD_LEAD_STATUS, submitLeadStatus)
  yield takeEvery(GET_LEAD_STATUS, fetchLeadStatus)
  yield takeEvery(DELETE_LEAD_STATUS, onDeleteLeadStatus)
  yield takeEvery(UPDATE_LEAD_STATUS, onUpdateLeadStatus)

  yield takeEvery(ADD_LEAD_TYPE, submitLeadType)
  yield takeEvery(GET_LEAD_TYPE, fetchLeadType)
  yield takeEvery(DELETE_LEAD_TYPE, onDeleteLeadType)
  yield takeEvery(UPDATE_LEAD_TYPE, onUpdateLeadType)

  yield takeEvery(ADD_NOTE_TYPE, submitNoteType)
  yield takeEvery(GET_NOTE_TYPE, fetchNoteType)
  yield takeEvery(DELETE_NOTE_TYPE, onDeleteNoteType)
  yield takeEvery(UPDATE_NOTE_TYPE, onUpdateNoteType)


  yield takeEvery(ADD_PROJECT_DOCUMENT_TYPE, submitProjectDocType)
  yield takeEvery(GET_PROJECT_DOCUMENT_TYPE, fetchProjectDocType)
  yield takeEvery(DELETE_PROJECT_DOCUMENT_TYPE, onDeleteProjectDocType)
  yield takeEvery(UPDATE_PROJECT_DOCUMENT_TYPE, onUpdateProjectDocType)


  yield takeEvery(ADD_PROJECT_STATUS, submitProjectStatus)
  yield takeEvery(GET_PROJECT_STATUS, fetchProjectStatus)
  yield takeEvery(DELETE_PROJECT_STATUS, onDeleteProjectStatus)
  yield takeEvery(UPDATE_PROJECT_STATUS, onUpdateProjectStatus)

  yield takeEvery(ADD_PROJECT_TYPE, submitProjectType)
  yield takeEvery(GET_PROJECT_TYPE, fetchProjectType)
  yield takeEvery(DELETE_PROJECT_TYPE, onDeleteProjectType)
  yield takeEvery(UPDATE_PROJECT_TYPE, onUpdateProjectType)


  yield takeEvery(ADD_SERVICE_TYPE, submitServiceType)
  yield takeEvery(GET_SERVICE_TYPE, fetchServiceType)
  yield takeEvery(DELETE_SERVICE_TYPE, onDeleteServiceType)
  yield takeEvery(UPDATE_SERVICE_TYPE, onUpdateServiceType)


  yield takeEvery(ADD_TASK_PRIORITY, submitTaskPriority)
  yield takeEvery(GET_TASK_PRIORITY, fetchTaskPriority)
  yield takeEvery(DELETE_TASK_PRIORITY, onDeleteTaskPriority)
  yield takeEvery(UPDATE_TASK_PRIORITY, onUpdateTaskPriority)


  yield takeEvery(ADD_TASK_REMINDER, submitTaskReminder)
  yield takeEvery(GET_TASK_REMINDER, fetchTaskReminder)
  yield takeEvery(DELETE_TASK_REMINDER, onDeleteTaskReminder)
  yield takeEvery(UPDATE_TASK_REMINDER, onUpdateTaskReminder)

  yield takeEvery(ADD_TASK_STATUS, submitTaskStatus)
  yield takeEvery(GET_TASK_STATUS, fetchTaskStatus)
  yield takeEvery(DELETE_TASK_STATUS, onDeleteTaskStatus)
  yield takeEvery(UPDATE_TASK_STATUS, onUpdateTaskStatus)

  yield takeEvery(ADD_TASK_TYPE, submitTaskType)
  yield takeEvery(GET_TASK_TYPE, fetchTaskType)
  yield takeEvery(DELETE_TASK_TYPE, onDeleteTaskType)
  yield takeEvery(UPDATE_TASK_TYPE, onUpdateTaskType)


  yield takeEvery(ADD_TRANSACTION_TYPE, submitTransType)
  yield takeEvery(GET_TRANSACTION_TYPE, fetchTransType)
  yield takeEvery(DELETE_TRANSACTION_TYPE, onDeleteTransType)
  yield takeEvery(UPDATE_TRANSACTION_TYPE, onUpdateTransType)

  yield takeEvery(ADD_TRANSACTION_COMMISSION_TYPE, submitTransCommType)
  yield takeEvery(GET_TRANSACTION_COMMISSION_TYPE, fetchTransCommType)
  yield takeEvery(DELETE_TRANSACTION_COMMISSION_TYPE, onDeleteTransCommType)
  yield takeEvery(UPDATE_TRANSACTION_COMMISSION_TYPE, onUpdateTransCommType)


  yield takeEvery(ADD_TRANSACTION_REF_TYPE, submitTransRefType)
  yield takeEvery(GET_TRANSACTION_REF_TYPE, fetchTransRefType)
  yield takeEvery(DELETE_TRANSACTION_REF_TYPE, onDeleteTransRefType)
  yield takeEvery(UPDATE_TRANSACTION_REF_TYPE, onUpdateTransRefType)

  yield takeEvery(ADD_TRANSACTION_STATUS_TYPE, submitTransStatusType)
  yield takeEvery(GET_TRANSACTION_STATUS_TYPE, fetchTransStatusType)
  yield takeEvery(DELETE_TRANSACTION_STATUS_TYPE, onDeleteTransStatusType)
  yield takeEvery(UPDATE_TRANSACTION_STATUS_TYPE, onUpdateTransStatusType)


  yield takeEvery(ADD_LISTING_TYPE, submitListingType)
  yield takeEvery(GET_LISTING_TYPE, fetchListingType)
  yield takeEvery(DELETE_LISTING_TYPE, onDeleteListingType)
  yield takeEvery(UPDATE_LISTING_TYPE, onUpdateListingType)


  yield takeEvery(ADD_LISTING_STATUS, submitListingStatus)
  yield takeEvery(GET_LISTING_STATUS, fetchListingStatus)
  yield takeEvery(DELETE_LISTING_STATUS, onDeleteListingStatus)
  yield takeEvery(UPDATE_LISTING_STATUS, onUpdateListingStatus)

  yield takeEvery(ADD_SHOWING_STATUS, submitShowingStatus)
  yield takeEvery(GET_SHOWING_STATUS, fetchShowingStatus)
  yield takeEvery(DELETE_SHOWING_STATUS, onDeleteShowingStatus)
  yield takeEvery(UPDATE_SHOWING_STATUS, onUpdateShowingStatus)


  
  yield takeEvery(ADD_EMAIL_LIST_TYPE, submitEmailListType)
  yield takeEvery(GET_EMAIL_LIST_TYPE, fetchEmailListType)
  yield takeEvery(DELETE_EMAIL_LIST_TYPE, onDeleteEmailListType)
  yield takeEvery(UPDATE_EMAIL_LIST_TYPE, onUpdateEmailListType)


  yield takeEvery(ADD_EMAIL_LIST_TARGET, submitEmailListTarget)
  yield takeEvery(GET_EMAIL_LIST_TARGET, fetchEmailListTarget)
  yield takeEvery(DELETE_EMAIL_LIST_TARGET, onDeleteEmailListTarget)
  yield takeEvery(UPDATE_EMAIL_LIST_TARGET, onUpdateEmailListTarget)


  
  yield takeEvery(ADD_CAMPAIGN_EMAIL_LIST, submitCampaignEmailList)
  yield takeEvery(GET_CAMPAIGN_EMAIL_LIST, fetchCampaignEmailList)
  yield takeEvery(DELETE_CAMPAIGN_EMAIL_LIST, onDeleteCampaignEmailList)
  yield takeEvery(UPDATE_CAMPAIGN_EMAIL_LIST, onUpdateCampaignEmailList)


  yield takeEvery(GET_APP_BY_PAGE_TYPE, fetchAppByPageType)
  yield takeEvery(UPDATE_APP_BY_PAGE_TYPE, onUpdateCalendarApp)
  yield takeEvery(DELETE_APP_BY_PAGE_TYPE, onDeleteCalendarApp)
}


export default ObjectSaga
